import { Link, useParams } from "react-router-dom";

interface FileLinkProps {
  id: string;
  name: string;
  folderId?: string;
}

export function FileLink({ id, name, folderId }: FileLinkProps) {
  const { dealId } = useParams<{ dealId: string }>();

  const to = folderId
    ? `/deal/${dealId}/documents/folder/${folderId}/file/${id}`
    : `/deal/${dealId}/documents/file/${id}`;

  return (
    <Link
      to={to}
      className="font-semibold text-sm text-persian-800 hover:text-persian-700"
    >
      {name}
    </Link>
  );
}
